<template>
  <div data-test-id="main-view">
    <router-view />
    <modals-container />
    <IstDialog />
  </div>
</template>

<script lang="ts" setup>
  import IstDialog from '@/components/IstDialog.vue';
</script>

<style lang="scss">
  #app {
    font-family: 'Libre Franklin', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: $ist-color-ist-xdark;
  }
  #nav {
    padding: 30px;
    a {
      font-weight: bold;
      color: $ist-color-ist-xdark;
      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }
  #userloading {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    min-height: 100vh;
  }
  #userloading p {
    width: 450px;
    max-width: 90%;
    height: 80px;
    background-color: $ist-color-blue;
    color: #fff;
    border-radius: 10px;
    transform: translate(0, -50%);
    vertical-align: middle;
    line-height: 80px;
  }
</style>
